export default "__VITE_ASSET__20MPYHij__"